(() => {
  const DATA_ID = "kmr-isw-promos-data";

  const CLS = {
    iswGrid: "kmr-isw-grid",
    iswBannerLi: "kmr-isw-promo-banner-li",
    badge: "kmr-boost-promo-badge",
    resultsBanner: "kmr-boost-results-banner",
  };

  const DEBUG = () => window.KMR_BOOST_PROMOS_DEBUG === true;
  const log = (...a) => DEBUG() && console.log("[KMR BOOST PROMOS]", ...a);

  const splitCsv = (csv) =>
    (csv || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

  const readPromos = () => {
    const el = document.getElementById(DATA_ID);
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.textContent || "[]");
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (e) {
      log("JSON parse failed", e);
      return [];
    }
  };

  const matchesTerm = (query, term, matchType) => {
    const q = (query || "").trim().toLowerCase();
    const t = (term || "").trim().toLowerCase();
    if (!q || !t) return false;
    if (matchType === "contains") return q.includes(t);
    if (matchType === "starts_with") return q.startsWith(t);
    return q === t;
  };

  const scorePromo = (query, promo) => {
    const q = (query || "").trim();
    const terms = splitCsv(promo?.trigger_terms);
    if (!q || !terms.length || !promo?.enabled) return -1;

    const base =
      promo.match_type === "exact" ? 300 :
      promo.match_type === "starts_with" ? 200 :
      100;

    let best = -1;
    for (const term of terms) {
      if (matchesTerm(q, term, promo.match_type)) {
        best = Math.max(best, base + term.length);
      }
    }
    return best;
  };

  const choosePromo = (query, promos) => {
    let best = null;
    let bestScore = -1;
    for (const p of promos) {
      const s = scorePromo(query, p);
      if (s > bestScore) {
        bestScore = s;
        best = p;
      }
    }
    return best;
  };

  const promoKey = (p) =>
    [
      p?.match_type,
      p?.trigger_terms,
      p?.banner_img,
      p?.banner_link,
      p?.banner_alt,
      p?.badge_img,
      p?.badge_mode,
      p?.badge_keywords,
    ].join("|");

  /* -------------------------
     Query sources
     ------------------------- */
  const getIswSearchInput = () =>
    document.querySelector(".boost-sd__search-widget-init-wrapper input[type='search']") ||
    document.querySelector(".boost-sd__search-widget-init-wrapper input[name='q']");

  const getResultsQueryFromUrl = () => {
    try {
      const u = new URL(window.location.href);
      return u.searchParams.get("q") || u.searchParams.get("query") || "";
    } catch {
      return "";
    }
  };

  const getActiveQuery = () => {
    const iswInput = getIswSearchInput();
    if (iswInput && document.querySelector(".boost-sd__search-widget-init-wrapper")) {
      return iswInput.value || "";
    }
    return getResultsQueryFromUrl();
  };

  /* -------------------------
     ISW (instant search widget)
     ------------------------- */
  const getIswProductsUL = () =>
    document.querySelector(
      ".boost-sd__search-widget-init-wrapper .boost-sd__instant-search-column--products ul.boost-sd__instant-search-product-list-items"
    );

  const cleanupIsw = (ul) => {
    if (!ul) return;
    ul.classList.remove(CLS.iswGrid);
    ul.querySelectorAll(`li.${CLS.iswBannerLi}`).forEach((n) => n.remove());
    ul.querySelectorAll(`img.${CLS.badge}`).forEach((n) => n.remove());
    // remove inline grid styles if we set them
    ["display","grid-template-columns","grid-auto-rows","grid-auto-flow","gap","align-items"]
      .forEach(p => ul.style.removeProperty(p));
  };

  const setIswGridMode = (ul, on) => {
    if (!ul) return;

    if (!on) {
      ul.classList.remove(CLS.iswGrid);
      ["display","grid-template-columns","grid-auto-rows","grid-auto-flow","gap","align-items"]
        .forEach(p => ul.style.removeProperty(p));
      return;
    }

    // This is what actually beats Boost's flex styles
    ul.classList.add(CLS.iswGrid);

    const vw = window.innerWidth;
    const cols = vw <= 700 ? 1 : vw <= 1100 ? 2 : 3;
    const row = vw <= 700 ? "auto" : "230px";

    ul.style.setProperty("display", "grid", "important");
    ul.style.setProperty("grid-template-columns", `repeat(${cols}, minmax(0, 1fr))`, "important");
    ul.style.setProperty("grid-auto-rows", row, "important");
    ul.style.setProperty("grid-auto-flow", "dense", "important");
    ul.style.setProperty("gap", "18px", "important");
    ul.style.setProperty("align-items", "start", "important");
  };

  const ensureIswBannerTile = (ul, promo) => {
    if (!ul || !promo?.banner_img) return;

    const key = promoKey(promo);
    const existing = ul.querySelector(`li.${CLS.iswBannerLi}`);
    if (existing && existing.dataset.kmrKey === key) return;
    if (existing) existing.remove();

    const li = document.createElement("li");
    li.className = `boost-sd__suggestion-queries-item boost-sd__suggestion-queries-item--product ${CLS.iswBannerLi}`;
    li.dataset.kmrKey = key;

    const href = promo.banner_link || "#";
    const alt = promo.banner_alt || "Promotion";

    li.innerHTML = `
      <a class="boost-sd__suggestion-queries-item-link" href="${href}" target="_parent" rel="noreferrer" aria-label="${alt}">
        <img src="${promo.banner_img}" alt="${alt}" loading="eager">
      </a>
    `;

    ul.insertBefore(li, ul.firstChild);
  };

  const iswProductCards = (ul) =>
    ul?.querySelectorAll("li.boost-sd__suggestion-queries-item--product:not(." + CLS.iswBannerLi + ")") || [];

  /* -------------------------
     Results page (SRP)
     ------------------------- */
  const getResultsProductListContainer = () => {
    // try common Boost selectors first
    return (
      document.querySelector("ul.boost-sd__product-list") ||
      document.querySelector("ul.boost-sd__product-list-items") ||
      document.querySelector(".boost-sd__product-list") ||
      document.querySelector("[class*='boost-sd__product-list'] ul") ||
      null
    );
  };

  const cleanupResults = (container) => {
    if (!container) return;
    container.querySelectorAll(`img.${CLS.badge}`).forEach((n) => n.remove());
    const existing = document.querySelector(`.${CLS.resultsBanner}`);
    if (existing) existing.remove();
  };

  const ensureResultsBannerStrip = (container, promo) => {
    if (!container || !promo?.banner_img) return;

    // Insert strip above the product list (safe layout change)
    const parent = container.parentElement || container;
    if (!parent) return;

    const key = promoKey(promo);
    const existing = parent.querySelector(`.${CLS.resultsBanner}`);
    if (existing && existing.dataset.kmrKey === key) return;
    if (existing) existing.remove();

    const wrap = document.createElement("div");
    wrap.className = CLS.resultsBanner;
    wrap.dataset.kmrKey = key;

    const href = promo.banner_link || "#";
    const alt = promo.banner_alt || "Promotion";

    wrap.innerHTML = `
      <a href="${href}" rel="noreferrer" aria-label="${alt}">
        <img src="${promo.banner_img}" alt="${alt}" loading="eager">
      </a>
    `;

    parent.insertBefore(wrap, container);
  };

  /* -------------------------
     Badges (ISW + SRP)
     ------------------------- */
  const keywordList = (csv) => splitCsv(csv).map((k) => k.toLowerCase());

  const badgeEligible = (title, promo) => {
    if (!promo?.badge_img) return false;
    if (promo.badge_mode === "all") return true;

    const keys = keywordList(promo.badge_keywords);
    if (!keys.length) return false;

    const t = (title || "").toLowerCase();
    return keys.some((k) => t.includes(k));
  };

  const injectBadgeIntoCard = (cardEl, promo, title) => {
    if (!cardEl || !promo?.badge_img) return;
    if (cardEl.querySelector(`img.${CLS.badge}`)) return;
    if (!badgeEligible(title, promo)) return;

    // Try to find an image wrapper we can position against
    const img =
      cardEl.querySelector("img") ||
      null;

    const anchor = (img && img.closest("a")) || img?.parentElement || cardEl;
    if (!anchor) return;

    const cs = getComputedStyle(anchor);
    if (cs.position === "static") anchor.style.position = "relative";

    const badge = document.createElement("img");
    badge.className = CLS.badge;
    badge.src = promo.badge_img;
    badge.alt = "";
    badge.loading = "lazy";

    anchor.appendChild(badge);
  };

  const addBadgesToIsw = (ul, promo) => {
    if (!ul || !promo?.badge_img) return;
    iswProductCards(ul).forEach((card) => {
      const title = card.getAttribute("data-title") || card.getAttribute("data-name") || "";
      injectBadgeIntoCard(card, promo, title);
    });
  };

  const addBadgesToResults = (container, promo) => {
    if (!container || !promo?.badge_img) return;

    // Try to target product items; fall back to “anything that looks like a product card”
    const cards =
      container.querySelectorAll("li")?.length
        ? container.querySelectorAll("li")
        : container.querySelectorAll("div");

    cards.forEach((card) => {
      const title =
        card.getAttribute("data-title") ||
        card.getAttribute("data-name") ||
        card.querySelector("[class*='title']")?.textContent?.trim() ||
        "";
      injectBadgeIntoCard(card, promo, title);
    });
  };

  /* -------------------------
     Apply
     ------------------------- */
  let lastKey = null;
  let applying = false;

  const apply = () => {
    if (applying) return;
    applying = true;

    try {
      const promos = readPromos();
      if (!promos.length) return;

      const query = getActiveQuery();
      const promo = choosePromo(query, promos);
      const key = promo ? promoKey(promo) : null;

      const ul = getIswProductsUL();
      const resultsList = getResultsProductListContainer();

      // cleanup if promo changed / removed
      if (key !== lastKey) {
        cleanupIsw(ul);
        cleanupResults(resultsList);
        lastKey = key;
      }

      if (!promo) return;

      // ISW: banner tile + grid only if banner exists
      if (ul) {
        if (promo.banner_img) {
          setIswGridMode(ul, true);
          ensureIswBannerTile(ul, promo);
        } else {
          setIswGridMode(ul, false);
        }
        addBadgesToIsw(ul, promo);
      }

      // Results page: banner strip above results + badges
      if (resultsList) {
        ensureResultsBannerStrip(resultsList, promo);
        addBadgesToResults(resultsList, promo);
      }
    } catch (e) {
      log("apply error", e);
    } finally {
      applying = false;
    }
  };

  // throttle
  let raf = null;
  const scheduleApply = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      apply();
    });
  };

  // Observe Boost rerenders
  const mo = new MutationObserver(() => scheduleApply());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // typing in search inputs
  document.addEventListener(
    "input",
    (e) => {
      const t = e.target;
      if (t && (t.matches("input[type='search']") || t.matches("input[name='q']"))) {
        scheduleApply();
      }
    },
    true
  );

  // URL changes
  window.addEventListener("popstate", scheduleApply);
  window.addEventListener("hashchange", scheduleApply);

  // responsive (ISW grid cols)
  window.addEventListener("resize", () => {
    const ul = getIswProductsUL();
    if (ul && ul.classList.contains(CLS.iswGrid)) setIswGridMode(ul, true);
  });

  // expose
  window.KMR_BOOST_PROMOS_APPLY = apply;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleApply);
  } else {
    scheduleApply();
  }
})();
